import productImage from '@/assets/banner/product.png'
import paymentImage from '@/assets/banner/payment.png'
import shippingImage from '@/assets/banner/shipping.png'

import productMobileImage from '@/assets/banner/product_mobile.png'
import paymentMobileImage from '@/assets/banner/payment_mobile.png'
import shippingMobileImage from '@/assets/banner/shipping_mobile.png'

export function getBannerImages () {
  return [
    productImage,
    paymentImage,
    shippingImage
  ]
}

export function getBannerMobileImages () {
  return [
    productMobileImage,
    paymentMobileImage,
    shippingMobileImage
  ]
}
